export class TituloModel {

    constructor(
        public encabezado: string
    ){}

}

export class FormBusquedaModel{

    constructor(
        public formlabel: string
    ){}

}

export class GrillaModel{

    constructor(
        public id: string,
        public run:string,
        public nombre:string,
        public botones:string
    ){}
}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/
